"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LongUrlRetrieverService = void 0;
const base64_1 = require("./base64");
class LongUrlRetrieverService {
    async send(shortUrl) {
        if (!shortUrl ||
            shortUrl.length > LongUrlRetrieverService.MAX_SHORT_URL_LENGTH ||
            !LongUrlRetrieverService.SHORT_URL_PATTERN.test(shortUrl)) {
            return null;
        }
        const response = await fetch(`/ods.svc/retrieveLongURL`, {
            method: 'POST',
            headers: {
                accept: 'application/json',
                'OData-Version': '4.0',
                consumer: 'id=A0056099-8CC7YJYS05J7L89Y;type=WEB',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                shrtURLTxt: shortUrl,
                domnDesc: this.getDomainDescription()
            })
        });
        const data = await response.json();
        return this.decodeBase64Unicode(data.value.longURLtxt || null);
    }
    decodeBase64Unicode(input) {
        if (typeof input !== 'string')
            return null;
        try {
            const decoded = (0, base64_1.b64DecodeUnicode)(input);
            new URL(decoded);
            return decoded;
        }
        catch {
            console.error('Failed to decode or validate base64 unicode string');
            return null;
        }
    }
    getDomainDescription() {
        if (typeof window !== 'undefined' && window.location) {
            const hostname = window.location.hostname;
            if (/^www\.ameriprise\.com$/.test(hostname)) {
                return 'www.ameriprise.com';
            }
        }
        return 'www.qa.ameriprise.com';
    }
}
exports.LongUrlRetrieverService = LongUrlRetrieverService;
LongUrlRetrieverService.MAX_SHORT_URL_LENGTH = 256;
// Base-62 encoding uses digits and letters only (0-9, A-Z, a-z).
LongUrlRetrieverService.SHORT_URL_PATTERN = /^[A-Za-z0-9]+$/;
